import { transformToCdnUrl } from 'utils/google-storage-util';

export const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
};

export const getEcomIcon = (ecomType: string) => {
    switch (ecomType) {
        case 'SHOPIFY':
        default:
            return transformToCdnUrl('embedded-assets/logos/shopify.png');
    }
};

export const filterObjectByKeys = (objToFilter: Record<string, unknown>, keys: string[]) => {
    return Object.keys(objToFilter)
        .filter((key) => keys.includes(key))
        .reduce((obj, key) => {
            obj[key] = objToFilter[key];
            return obj;
        }, {});
};

export const objectHasKey = (object: Record<string, unknown>, key: string | number) => {
    return Object.prototype.hasOwnProperty.call(object, key);
};

export const copyTextToClipboard = async (text: string) => {
    if (window.isSecureContext && navigator.clipboard) {
        return navigator.clipboard.writeText(text);
    }

    throw new Error(
        'Copy to clipboard is blocked because browser is not in secure context (e.g. page is not served over HTTPS)'
    );
};

export const downloadFileContent = (contentBase64: string, filename: string) => {
    const byteCharacters = atob(contentBase64);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray]);

    const url = window.URL.createObjectURL(new Blob([blob]));

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', filename);
    document.body.appendChild(anchor);
    anchor.click();
    anchor?.parentNode?.removeChild(anchor);
};

export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export function dateToString(date: Date) {
    return (
        date.getFullYear() +
        '-' +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        date.getDate().toString().padStart(2, '0')
    );
}

export function subtractMonths(date, months) {
    date.setMonth(date.getMonth() - months);
    return date;
}

export function openBlob(data: unknown, type = 'application/pdf') {
    const file = new Blob([data as BlobPart], { type });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
}

export const isNullOrUndefinedOrEmpty = (value: unknown): boolean => {
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }

    if (typeof value === 'string' && value === '') {
        return true;
    }

    return isNullOrUndefined(value);
};

export const delayPromise = (delayInms: number) => {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
};
